import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/evCo6MAXDuPkKQHJ56hyHG/MOCKUP_STICKERR.png';
function ensureMeta(attributes: Record<string, string>) {
  const selector = Object.entries(attributes).filter(([key]) => key !== 'content').map(([key, value]) => `[${key}="${value}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attributes).forEach(([key, value]) => meta?.setAttribute(key, value));
}
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'Método Porción Rentable® — Convertí postres en ganancias';
    ensureMeta({
      name: 'description',
      content: 'Recetas rentables - porciones que venden - presentación premium - packaging - costos - ventas y organización para emprender desde casa.'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = MOCKUP_URL;
    document.head.appendChild(preload);
    return () => preload.remove();
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandOrange selection:text-white notranslate" data-id="element-0" data-mp="ssstcwp0use3">
      <MetaPixel data-id="element-1" data-mp="3udkr489qbgg7" />
      <SocialProofPopup data-id="element-2" data-mp="3ubzw6hji5vht" />
      <Hero data-id="element-3" data-mp="3uevq7us8c00z" />
      <SocialProof data-id="element-4" data-mp="d4nxjm8nzu51" />
      <Testimonials1 data-id="element-5" data-mp="d57hf8hvkslp" />
      <Problem data-id="element-6" data-mp="d3mmhhrnf7nb" />
      <ProductTomos data-id="element-7" data-mp="d45tw4joadn3" />
      <Bonuses data-id="element-8" data-mp="d2l7513lnyzs" />
      <UrgencyCounter data-id="element-9" data-mp="85l28tihl2a9" />
      <Pricing data-id="element-10" data-mp="85bbv4tj4t41" />
      <Potenciador data-id="element-11" data-mp="86mc4unrniqe" />
      <Testimonials2 data-id="element-12" data-mp="86cnpbiddjmt" />
      <Guarantee data-id="element-13" data-mp="83qihiiybg7r" />
      <FAQ data-id="element-14" data-mp="3gl4r7gc4jyji" />
      <CostOfNotHaving data-id="element-15" data-mp="3gkuy3jvs9b9l" />
      <FinalCTA data-id="element-16" data-mp="3gm665vw9h56i" />
      <Footer data-id="element-17" data-mp="3glo0k8nplelx" />
    </div>;
}